/*!
* IE10 viewport hack for Surface/desktop Windows 8 bug
* Copyright 2014-2015 Twitter, Inc.
* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
*/

// See the Getting Started docs for more information:
// http://getbootstrap.com/getting-started/#support-ie10-width

(function () {
    'use strict';

    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement('style')
        msViewportStyle.appendChild(
            document.createTextNode(
                '@-ms-viewport{width:auto!important}'
            )
        )
        document.querySelector('head').appendChild(msViewportStyle)
    }

})();

$(document).ready(function(){
    $('input').iCheck({
        checkboxClass: 'icheckbox_flat-red',
        radioClass: 'iradio_flat-red',
        increaseArea: '20%' // optional
    });

    $('.cta-naprej').on('click', function(event) {
        event.preventDefault();

        $('.step-1').hide();
        $('.step-2').show();

        return false;
    })

    // var points = [
    //     { value: $('.morph .m1').attr('d') },
    //     { value: $('.morph .m2').attr('d') },
    //     { value: $('.morph .m3').attr('d') },
    //     // { value: $('.morph .m4').attr('d') },
    // ];
    //
    // anime({
    //     targets: '.morph path',
    //     d: points,
    //     easing: 'easeOutBack',
    //     direction: 'alternate',
    //     loop: true,
    //     duration: function() { return anime.random(3000, 6000); },
    //     delay: function() { return anime.random(0, 2000); },
    //     offset: +500
    //     // elasticity: function() { return anime.random(0, 600); }
    // });

    function animateButton(element, scale, duration, elasticity) {
        anime.remove(element);
        anime({
            targets: element,
            scale: scale,
            duration: duration,
            elasticity: elasticity
        });
    }

    function enterButton(el) { animateButton(el, 1.1, 800, 400) };
    function leaveButton(el) { animateButton(el, 1.0, 600, 300) };

    $('.cta-naprej').mouseenter(function () {
        enterButton(this);
    });
    $('.cta-naprej').mouseleave(function () {
        leaveButton(this);
    });
    $('.cta-potrdi').mouseenter(function () {
        enterButton(this);
    });
    $('.cta-potrdi').mouseleave(function () {
        leaveButton(this);
    });
    $('.cta-fb').mouseenter(function () {
        enterButton(this);
    });
    $('.cta-fb').mouseleave(function () {
        leaveButton(this);
    });

    $('#name_surname').on('keyup', function(event) {
        if ($(this).val().length > 0) {
            $(this).closest('.form-group').removeClass('has-error');
        } else {
            $(this).closest('.form-group').addClass('has-error');
        }
    });

    $('#answer').on('keyup', function(event) {
        if ($(this).val().length > 0) {
            $(this).closest('.form-group').removeClass('has-error');
        } else {
            $(this).closest('.form-group').addClass('has-error');
        }
    });

    $('#agree_1').on('ifToggled', function(event) {
        if ($(this).prop('checked')) {
            $(this).closest('.form-group').removeClass('has-error');
        } else {
            $(this).closest('.form-group').addClass('has-error');
        }
    });

    function validateEmail(email)
    {
      var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    }

    $('#email').on('keyup', function(event) {
        if ($(this).val().length > 0) {
            if (validateEmail($(this).val())) {
                $(this).closest('.form-group').removeClass('has-error');
            } else {
                $(this).closest('.form-group').addClass('has-error');
            }
        } else {
            $(this).closest('.form-group').addClass('has-error');
        }
    });
});
